import React from 'react';
import classNames from 'classnames';
import { useAuthContext } from '../../context/AuthContext';
import { bindEvents } from '@/utils/sensors';
import { useLottie } from 'lottie-react';
import animationData from '@/pages/prediction-score/predict.json';
import type { IHomePagePredictionScore } from '@/types';
import { useCommonInfoContext } from '../../context/CommonInfoProvider';

const lottieOptions = {
    animationData: animationData,
    loop: true,
};

const lottieStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 80,
    height: 80,
};

interface PredictionScoreCardProps {
    dataSource: IHomePagePredictionScore['predictionScore'];
}

const PredictionScoreCard: React.FC<PredictionScoreCardProps> = ({ dataSource }) => {
    const { authUtils } = useAuthContext();
    const {
        commonInfo: { projectId, subjectId },
    } = useCommonInfoContext();

    const { predictionScore, studentPredictionStatus, goalScore, predictionScoreIntroduceH5Url, totalScore } = dataSource;

    const isGoalCompleted = goalScore && predictionScore ? predictionScore >= goalScore : false;

    const handleOpenIntroduce = authUtils.withFullAuthCheck(
        () => {
            // 如果学员预测分已开启，则展示详情
            window.open(predictionScoreIntroduceH5Url, '_blank');
        },
        {
            alwaysCall: () =>
                bindEvents('Click_PredictedScore', {
                    name: '点击预测分卡片',
                    project_id: projectId,
                    subject_id: subjectId,
                }),
        }
    );

    const { View } = useLottie(lottieOptions, lottieStyle);

    return (
        <div
            className={classNames('sub-tiku__predict-score-card', {
                completed: isGoalCompleted,
            })}
            onClick={handleOpenIntroduce}
        >
            <div className="sub-tiku__predict-score-card-title">
                <span className="em">预测分</span>/总分
            </div>
            <div className="sub-tiku__predict-score-card-content">
                {studentPredictionStatus === 0 ? (
                    <div className="sub-tiku__tiku-default-btn sub-tiku__predict-score-get-score-btn">获取预测分</div>
                ) : (
                    <div className="predict-score-numbers">
                        <span className="strong">{predictionScore ?? '--'}</span>/{totalScore}
                    </div>
                )}
            </div>
            {View}
        </div>
    );
};

export default PredictionScoreCard;
